import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ConnectionService } from '../../shared/services/Connection/connection.service';
import { CacheService } from '../../shared/services/Cache/cache.service';

@Injectable({
  providedIn: 'root',
})
export class IdentificationGuard implements CanActivate {
  constructor(private router: Router, private connection: ConnectionService, private cacheService: CacheService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot,): boolean {

    const fullUrl = state.url;
    const nameCompany = route.params['nameCompany']

    if(fullUrl == "/")
    {
      let name = this.cacheService.getItemLocal('nameCompany');
      let type = this.cacheService.getItemSession('typeParam');
      const number = this.cacheService.getItemSession('numberParam');

      this.connection.updateNameCompany(nameCompany)

      if(!name)
      {
        name = '';
      }
      if(!type)
      {
        type = '';
      }

      if(name == '')
      {
        // return false
        this.router.navigate(['/landing/home']);
      }
      else{

        if(type == '')
        {
          this.router.navigate([name]);
        }
        else{
          this.router.navigate([name, type, number]);
        }

      }
    }
    else{
      this.connection.updateNameCompany(nameCompany)

      this.cacheService.clearCacheTimeout('qrCode_key');
      this.cacheService.clearCacheTimeout('counter_key');

    }

    return true
  }
}
